import { useEffect, useState } from "react";
import { getUserCertificates } from "crypto-pro";

export type CertificateOption = {
  thumbprint: string;
  owner: string;
};

/**
 * @returns возвращает список опций для селектора ЭЦП
 */
export const useCSPSelectOptions = () => {
  const [certificatesOptions, setCertificatesOptions] = useState<
    CertificateOption[]
  >([]);

  const takeAllCertificates = async () => {
    const certificates = await getUserCertificates();

    const parsedCertificateOptions = await Promise.all(
      certificates.map(async (certificate) => {
        const ownerInfo = await certificate.getOwnerInfo();
        return {
          thumbprint: certificate.thumbprint,
          owner: `${
            ownerInfo.find((info) => info.title === "Владелец")?.description
          } (ИНН ${
            ownerInfo.find((info) => info.title === "ИНН")?.description
          })`,
        };
      })
    );
    setCertificatesOptions(parsedCertificateOptions);
  };

  useEffect(() => {
    takeAllCertificates();
  }, []);

  return { certificatesOptions };
};
